import menu from "./menu"
import meta from "./meta"
import footer from "./footer"
import speakers from "./speakers"

function speaker(slug) {
  const { name, role, url } = speakers.find((speaker) => speaker.slug === slug)

  const hreftext = url.replace(/(^\w+:|^)\/\//, "").replace(/\/$/, "")
  return {
    name: name,
    description: role,
    href: url,
    hreftext: hreftext,
  }
}

const networking = {
  es: "Networking Puesta de sol",
  en: "Networking",
  ca: "Networking Posta de sol",
}

const dinner = {
  es: "Cena (opcional)",
  en: "Dinner (optional)",
  ca: "Sopar (opcional)",
}
const data = {
  menu,
  meta,
  components: [
    {
      name: "Wrapper",
      components: [
        {
          name: "Program",
          props: {
            hero: {
              title: {
                es: "Programa Formentera20 2025",
                en: "Formentera20 Program 2025",
                ca: "Programa Formentera20 2025",
              },
              description: {
                es:
                  "Creatividad, comunicación, marketing, plataformas digitales, contenidos, branding, IA, Redes Sociales, Video, Big Data...",
                en:
                  "Creativity, communication, marketing, digital platforms, content, branding, AI, social media, video, big data...",
                ca:
                  "Creativitat, comunicació, màrqueting, plataformes digitals, continguts, branding, IA, Xarxes Socials, Video, Big Data...",
              },
              image: "/schedule/1.jpg",
            },
            items: [
              {
                date: {
                  es: "Jueves, 2 de octubre",
                  en: "Thursday, October 2nd",
                  ca: "Dijous, 2 de octubre",
                },
                subitems: [
                    {
                        hour: "15:00h",
                        id: "subitem1",
                        name: {
                            es: "Recogida acreditaciones",
                            en: "Accreditation pickup",
                            ca: "Recollida d’acreditacions",
                        },
                    },
                  {
                    hour: "16:00h",
                    id: "subitem2",
                    name: {
                      es: "Inauguración / Bienvenida Rosa Castells",
                      en: "Opening Rosa Castells",
                      ca: "Inauguració / Benvinguda Rosa Castells",
                    },
                    speakers: [
                      {
                        name: "Rosa Castells",
                        description: {
                          es: "Dtra. & Creadora Formentera20",
                          en: "Formentera20 Founder",
                          ca: "Dtra. & Creadora Formentera20",
                        },
                        href: "https://rosacastells.net/",
                        hreftext: "www.rosacastells.net",
                      },
                    ],
                  },
                  {
                    hour: "16:15h",
                    id: "subitem3",
                    name: {
                      es: "Marta Prieto",
                      en: "Marta Prieto",
                      ca: "Marta Prieto",
                    },
                    speakers: [speaker("marta-prieto")],
                  },
                  {
                    hour: "17:15h",
                    id: "subitem4",
                    name: {
                      es: "Oscar Ordoñez",
                      en: "Oscar Ordoñez",
                      ca: "Oscar Ordoñez",
                    },
                    speakers: [speaker("oscar-ordoñez")],
                  },
                  {
                    hour: "18:15h",
                    id: "subitem5",
                    name: {
                      es: "Lorena Poza",
                      en: "Lorena Poza",
                      ca: "Lorena Poza",
                    },
                    speakers: [speaker("lorena-poza")],
                  },
                    {
                    hour: "19:00h",
                    id: "subitem6",
                    name: networking,
                  },
                   {
                    hour: "21:00h",
                    id: "subitem7",
                    name: dinner,
                  },
                ],
              },
              {
                date: {
                  es: "Viernes, 3 de octubre",
                  en: "Friday, October 3rd",
                  ca: "Divendres, 3 de octubre",
                },
                subitems: [
                  {
                    hour: "11:30h",
                    id: "subitem8",
                    name: {
                      es: "Nandu Jubany",
                      en: "Nandu Jubany",
                      ca: "Nandu Jubany",
                    },
                    speakers: [speaker("nandu-jubany")],
                  },
                  {
                    hour: "12.30h",
                    id: "subitem9",
                    name: {
                      es: "Anna Roca",
                      en: "Anna Roca",
                      ca: "Anna Roca",
                    },
                    speakers: [speaker("anna-roca")],
                  },
                  {
                    hour: "16:30h",
                    id: "subitem10",
                    name: {
                      es: "Joan Alvares",
                      en: "Joan Alvares",
                      ca: "Joan Alvares",
                    },
                    speakers: [speaker("joan-alvares")],
                  },
                  {
                    hour: "17:30h",
                    id: "subitem11",
                    name: {
                      es: "Santiago Miguélez",
                      en: "Santiago Miguélez",
                      ca: "Santiago Miguélez",
                    },
                    speakers: [speaker("santiago-miguelez")],
                  },
                    {
                    hour: "19:00h",
                    id: "subitem12",
                    name: networking,
                  },
                   {
                    hour: "21:00h",
                    id: "subitem13",
                    name: dinner,
                  },
                ],
              },
              {
                date: {
                  es: "Sábado, 4 de octubre",
                  en: "Saturday, October 4th",
                  ca: "Dissabte, 4 de octubre",
                },
                subitems: [
                  {
                    hour: "11:00h",
                    id: "subitem14",
                    name: {
                      es: "DEBATE : ‘IA Will Tear Us Apart’",
                      en: "DEBATE : ‘IA Will Tear Us Apart’",
                      ca: "DEBATE : ‘IA Will Tear Us Apart’",
                    },
                  },
                  {
                    hour: "14:00h",
                    id: "subitem15",
                    name: {
                      es: "CLAUSURA Formentera20",
                      en: "CLAUSURA Formentera20",
                      ca: "CLAUSURA Formentera20",
                    },
                    description: {
                      es: `* El orden y horarios de las presentaciones puede variar y variara por causas ajenas a la organización. <b>Seguirnos en redes sociales para ver actualizaciones de ponentes. </b>
                      <br><br>
                      Se enviará por mail días antes del evento.
                      <br><br>
                      * Los almuerzos /cenas no están incluidos. Enviaremos mail días antes por si quieres unirte.
                      <br><br>
                      ¡Gracias por seguirnos!
                      <br><br>
                      ¿Quieres venir con tu equipo? Escríbenos <a href="mailto:info@formentera20.com"><b>info@formentera20.com</b></a>
                      <br><br>
                      DesconectarParaConectar = Formentera20
                      <br><br>
                      <a href="https://www.formentera20.com" target="_blank" rel="noopener noreferrer"><b>www.formentera20.com</b></a>`,
                      ca: 
                      `* L’ordre i els horaris de les presentacions poden variar i variaran per causes alienes a l’organització. <b>Segueix-nos a les xarxes socials per veure actualitzacions dels ponents.</b>
                      <br><br>
                      S’enviarà per correu electrònic dies abans de l’esdeveniment.
                      <br><br>
                      * Els dinars / sopars no estan inclosos. T’enviarem un correu dies abans per si t’hi vols unir.
                      <br><br>
                      Gràcies per seguir-nos!
                      <br><br>
                      Vols venir amb el teu equip? Escriu-nos a <a href="mailto:info@formentera20.com"><b>info@formentera20.com</b></a>
                      <br><br>
                      DesconnectarPerConnectar = Formentera20
                      <br><br>
                      <a href="https://www.formentera20.com" target="_blank" rel="noopener noreferrer"><b>www.formentera20.com</b></a>`,
                      en: 
                      `* The schedule and order of presentations may change and will change due to reasons beyond the organization’s control. <b>Follow us on social media to see speaker updates.</b>
                      <br><br>
                      It will be sent via email a few days before the event.
                      <br><br>
                      * Lunches / dinners are not included. We’ll send an email a few days before in case you’d like to join.
                      <br><br>
                      Thanks for following us!
                      <br><br>
                      Want to come with your team? Write to us at <a href="mailto:info@formentera20.com"><b>info@formentera20.com</b></a>
                      <br><br>
                      DisconnectToConnect = Formentera20
                      <br><br>
                      <a href="https://www.formentera20.com" target="_blank" rel="noopener noreferrer"><b>www.formentera20.com</b></a>`
                    }
                  },
                ],
              },
              
            ],
          },
        },
      ],
    },
    footer,
  ],
}

export default data
